/**
 * The ten question kinds, shared verbatim by the builder (which authors them)
 * and the responder (which answers them). Both sides previously declared this
 * list independently — three copies in total — with no mechanism keeping them
 * in step.
 */
export const QUESTION_KINDS = {
  Choice: 'choice',
  ImageChoice: 'imageChoice',
  Rating: 'rating',
  Matrix: 'matrix',
  OpenEnded: 'openEnded',
  Ranking: 'ranking',
  Message: 'message',
  Url: 'url',
  Task: 'task',
  ContactInfo: 'contactInfo',
  MobileApp: 'mobileApp',
} as const;

export type QuestionKind = (typeof QUESTION_KINDS)[keyof typeof QUESTION_KINDS];

export const QUESTION_KIND_VALUES: readonly QuestionKind[] =
  Object.values(QUESTION_KINDS);
